import PropTypes from "prop-types";
import TextButton from "@shared/v2/TextButton";

const WorkingMonthsNotice = ({ workingMonths, onChange = null }) => (
  <div className="tw-mt-[12px] tw-flex tw-items-center tw-justify-start tw-gap-[8px]">
    <span className="tw-text-14d tw-italic tw-text-gray-50">
      Based on working <b>{workingMonths}</b> months out of the year
    </span>
    <TextButton schema="sentence" size="medium" onClick={onChange}>
      Change
    </TextButton>
  </div>
);

WorkingMonthsNotice.propTypes = {
  workingMonths: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};

export default WorkingMonthsNotice;
